export default __webpack_public_path__ + "static/media/0114.6496b66d.jpg";